import React from "react";


const Navbar = () => {
    return(
        <nav className="bg-cream p-4">
            <div className="container mx-auto flex justify-between items-center">
                <h1 className="text-black text-2xl font-bold">Fatimah Zahra</h1>
                <div>
                <a href="#about"
                className="text-black font-bold hover:text-rosegold border-b-2 border-black hover:border-rosegold pb-2  mx-20 mr-5 transition duration-300" // Menambahkan lebih banyak padding bottom
                style={{ borderBottomWidth: '3px', paddingBottom: '6px', borderBottomColor: '#000', width: '100px' }} // Mengatur lebar garis bawah
                >
                  About
                </a>
    <a href="#projects" className="text-black font-bold hover:text-rosegold mx-20 transition duration-300 ">Projects</a>
    <a href="#contact" className="text-black font-bold hover:text-rosegold mx-20 transition duration-300 ml-6">Contact</a>
</div>

                
            
            </div>
        </nav>
    )
}

export default Navbar;